import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import DataSource from 'devextreme/data/data_source';

import ArrayStore from 'devextreme/data/array_store';
import { Subject } from 'rxjs/internal/Subject';
import { map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { JobLogType } from '../../enums/job-log-type.enum';
import { Link } from '../../interfaces/link.interface';
import { JobLogService } from '../../services/job-log.service';
import { JobService } from '../../services/job.service';
import { LoggingUpdateSignalrService } from '../../services/signalR/logging-update-signalr.service';
import { LogTypePropertiesMapping } from '../../interfaces/logtype-properties-mapping.interface';
import { BehaviorSubject, pipe } from 'rxjs';
import { AsamcoAuthService, AsamcoUserService } from '@asamco/base';
import { LinkService } from '../../services/link.service';
import { PrettyJsonViewerComponent } from '../../integration-tester/pretty-json-viewer/pretty-json-viewer.component';
import { bind } from '@asamco/utils';
import { QueueService } from '../../services/queue.service';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DxoLoadPanelModule, DxoPagerModule, DxoScrollingModule, DxiColumnModule, DxoFilterRowModule, DxoPagingModule, DxoSelectionModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { NgIf, NgFor, NgSwitch, NgSwitchCase, NgSwitchDefault, AsyncPipe, DatePipe, JsonPipe } from '@angular/common';
import { DxPopupModule, DxDataGridModule, DxScrollViewModule } from 'devextreme-angular';
import { ALTabsComponent } from '@asamco/application-link/shared';
import ODataStore from 'devextreme/data/odata/store';
import { TimeDifferencePipe } from '../../pipes/timedifference.pipe';
import { AlCompanyService } from '../../services/al-company.service';
import { SelectedCompanyService } from '../../selected-company/selected-company.service';
import { TimezoneDatePipe } from '../../pipes/timezone_date.pipe';
import { JobLogHistory } from '../../interfaces/job-log-history.interface';

@Component({
	selector: 'al-link-log',
	templateUrl: './link-log.component.html',
	styleUrls: ['./link-log.component.scss'],
	standalone: true,
	imports: [
		DxPopupModule,
		NgIf,
		PrettyJsonViewerComponent,
		DxDataGridModule,
		DxoLoadPanelModule,
		DxoPagerModule,
		DxoScrollingModule,
		DxiColumnModule,
		DxoFilterRowModule,
		DxoPagingModule,
		DxTemplateModule,
		ALTabsComponent,
		DxScrollViewModule,
		NgFor,
		NgSwitch,
		NgSwitchCase,
		DxoSelectionModule,
		NgSwitchDefault,
		DxiButtonModule,
		AsyncPipe,
		DatePipe,
		TimeDifferencePipe,
		TimezoneDatePipe,
		JsonPipe
	],
})
export class LinkLogComponent implements OnInit, OnDestroy {
	/** Input of link id to get the logs */
	@Input()
	link: Link;

	@ViewChild('picklistcomponent', { static: false }) prettyJsonComponentpicklist: PrettyJsonViewerComponent;

	/** Tracking which properties we have to display in the JobLog DxDataGrid */
	SelectedProperties: string[] = [];
	SelectedDataSource: any = [];
	SelectedLogType: JobLogType;

	public LogTypPropertiesMapping: BehaviorSubject<LogTypePropertiesMapping[]> = new BehaviorSubject<LogTypePropertiesMapping[]>(
		[] as LogTypePropertiesMapping[]
	);
	//LogTypPropertiesMapping: LogTypePropertiesMapping[] = [] as LogTypePropertiesMapping[];

	private destroy$ = new Subject<void>();

	/** Bool to check if the connection is already open */
	isSignalrActive: boolean = false;

	/** List used for the JobLogType enum, for setting up the tabs which makes use of this enum type */
	enumList: JobLogType[];

	/** Job columns used for the DxDataGrid inside the DxSearchBox */
	gridColumns: string[] = ['CreationDate', 'TotalSucceeded', 'TotalFailed'];

	/** DxSearchBox allows for multi-select, but since we only have 1 Job selected at maximum, we'll always only reach out to the first element */
	public selectedJobInstanceId: string[] = [];
	/** Datasource used for the jobLogs */
	jobLogDataSource: any;
	/** DataSource used for the jobs */

	// jobDataSource: DataSource;

	/** Check for if the DxDataGrid inside the DxSearchBox has been opened */
	isGridBoxOpened: boolean;

	/** Tabs for the joblog datasource*/
	tabs: any[] = [];
	public tabsSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

	/** Default value for checking which tab is currently selected, default opens with All (because atleast that one always exists) */
	public selectedTab$: BehaviorSubject<number> = new BehaviorSubject<number>(JobLogType.All);

	/** Tracker to see if there is data available (otherwise don't show any grid and give a small message) */
	entriesAvailable: boolean = false;

	// public isExpandedMessageVisible: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	public isExpandedMessageVisible: boolean = false;

	public isExpandedMessageSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
	public expandedMessageContent: string = null;

	public hasLogBeenClicked: boolean = false;

	/** boolean used for single selected or full selection */
	//singleModeSelection: boolean = true;
	singleModeSelectionSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

	public isAdminSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public adminInstanceLog: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

	public jobDataSourceOData: ODataStore<JobLogHistory> = null;

	companyTimezone$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

	constructor(
		private loggingUpdateService: LoggingUpdateSignalrService,
		private jobLogService: JobLogService,
		private jobService: JobService,
		private asamcoUserService: AsamcoUserService,
		private asamcoAuthService: AsamcoAuthService,
		private companyService: AlCompanyService,
		private selectedCompanyService: SelectedCompanyService,
		) {
			this.getCurrentTimeZoneIfExists();
		this.selectedTab$.subscribe(tabId => this.changeDataSource(tabId));

		this.asamcoAuthService.authTokenChanged$.subscribe(
			(token) => {
				if (token.token) {
					this.jobDataSourceOData = new ODataStore<JobLogHistory>({
						deserializeDates: false,
						url: this.asamcoAuthService.userSession.backend.odataBaseUrl + 'JobLogHistories',
						version: 4,
						beforeSend: (e) => {
							e.headers = {
								"Authorization": `Bearer ${token.token}`,
								"X-company-id": this.link.companyId,
								"X-link-id": this.link.id,
							};
						}
					});
				}
			},
			(error) => {
				console.error('Error fetching the token:', error);
			}
		);
	}

	getCurrentTimeZoneIfExists() {
		this.selectedCompanyService.getCompanyIdObservable().subscribe(e => {
			this.companyService.getSingleCompany(e).subscribe(company => {
				if (!company.timezoneString) {
					this.companyTimezone$.next('UTC');
				}
				else {
					this.companyTimezone$.next(company.timezoneString);
				}
			})
		})
	}

	cellClicked($event) {
		if($event.rowType === 'data') {
			this.getJobsByJobId($event.data.instanceId);
		}
	}

	/** Setting up the tabs for the JobLogType */
	setupTabs() {
		let index = 0;

		this.enumList.forEach((element: JobLogType) => {
			// Should always be visible (only visible if it even has entities)
			// TODO?
			if (index !== JobLogType.All) {
				const itemCount = this.LogTypPropertiesMapping.getValue().filter(item => Number(item.LogType) === index);
				if (itemCount.length > 0) {
					let itemName: string = element.toString();
					if(index === JobLogType.AmountMismatch)
					{
						itemName = 'Mismatch';
					}

					this.tabs.push({ id: index, text: itemName + ' (' + itemCount[0].dataSource.length + ')', visible: false });
					this.tabsSubject.next(this.tabs);
				}
			}
			/** Entries are based on the JobLogType enum, and by looping through them one by one you always get the proper ID */
			index = index + 1;
		});

		// Add JobLogType.All at the end of the tabs array

		this.tabs.unshift({ id: JobLogType.All, text: this.enumList[JobLogType.All] , visible: true });
		this.tabsSubject.next(this.tabs);
	}

	getColumns(item: any[]) {
		//TODO: Check if this works in combination with SignalR
		this.LogTypPropertiesMapping.next([] as LogTypePropertiesMapping[]);
		item.forEach((e: any[]) => {
			e.forEach(b => {
				if (b.jobLogType && !this.LogTypPropertiesMapping.getValue().find(e => e.LogType == b.jobLogType)) {
					let tempProperty = [];
					tempProperty = Object.getOwnPropertyNames(b);
					//Removing default fields which require custom adjustments (or don't have to be visible within de DxDataGrid)
					tempProperty = tempProperty.filter(item1 => item1 !== 'creationDate');
					tempProperty = tempProperty.filter(item2 => item2 !== 'jobLogType');
					tempProperty = tempProperty.filter(item3 => item3 !== 'rowColor');
					tempProperty = tempProperty.filter(item4 => item4 !== 'jobLogId');

					this.LogTypPropertiesMapping.getValue().push({
						LogType: b.jobLogType,
						properties: tempProperty,
						dataSource: e,
					});
				}
			});
		});
	}

	// determine whether this is a column that should be displayed widely
	isWideColumn(columnName: string) {
		return ['message', 'description', 'difference'].includes(columnName);
	}

	//Helper function for converting enum to key/value par
	StringIsNumber = value => isNaN(Number(value)) === false;

	//function to convert enum to key/value pair
	toArray(enumme) {
		return Object.keys(enumme)
			.filter(this.StringIsNumber)
			.map(key => enumme[key]);
	}

	changeDataSource(joblogType) {
		//Remove and apply filter based on tab selection
		if (joblogType === JobLogType.All) {
			this.singleModeSelectionSubject.next(false);
		} else {
			//this.jobLogDataSource.filter('jobLogType', '=', event.itemIndex.toString());
			const item = this.LogTypPropertiesMapping.getValue().filter(item => item.LogType == joblogType.toString())[0];
			this.SelectedDataSource = item.dataSource;
			this.SelectedProperties = item.properties;
			this.SelectedLogType = item.LogType;
			this.singleModeSelectionSubject.next(true);
		}
	}

	retrieveJobLogs() {
		//Checking if the connection isn't already active
		if (!this.isSignalrActive) {
			this.enableSignalR();
		}
	}

	//FIX THIS: No more ID's -> instanceID's instead
	enableSignalR() {
		this.loggingUpdateService
			.getLoggerObservable()
			.pipe(takeUntil(this.destroy$))
			.subscribe(loggingUpdate => {
				this.isSignalrActive = true;

				// Check if the JobId matches the currently selected one
				if (loggingUpdate.jobInstanceId !== this.selectedJobInstanceId[0]) {
					return;
				}

				const logTypeProperties = this.LogTypPropertiesMapping.getValue();
				const matchingLogType = logTypeProperties.find(item => item.LogType === loggingUpdate.jobLogType);

				if (matchingLogType) {
					const currentDataSource = matchingLogType.dataSource;

					const mostRecentJobLogId = Math.max(...currentDataSource.map(o => Number(o.jobLogId)));

					this.jobLogService
						.getLatestFieldsByLogType({
							instanceId: this.selectedJobInstanceId[0],
							latestJobLogId: mostRecentJobLogId,
							jobLogType: loggingUpdate.jobLogType,
						})
						.subscribe(newLogs => {
							// Append each new entry to the datasource
							const item = logTypeProperties.find(prop => prop.LogType === newLogs[0].jobLogType);
							if (item) {
								newLogs.forEach(element => {
									item.dataSource.push(element);
								});
							}
						});
				} else {
					this.getJobsByJobId(this.selectedJobInstanceId[0]);
				}
			});
	}

	getJobsByJobId(instanceId: string) {
		this.jobLogService
			.get(instanceId)
			.pipe(
				tap(item => {
					this.getColumns(item);
				}),
				takeUntil(this.destroy$)
			)
			.subscribe(_ => {
				this.hasLogBeenClicked = true;
				if (this.LogTypPropertiesMapping.getValue().length > 0) {
					this.entriesAvailable = true;
					this.getDistinctItems();
					this.singleModeSelectionSubject.next(false);
				} else {
					this.entriesAvailable = false;
				}
			});
	}

	onRowPrepared(e) {
		if (e.rowType === 'data' && e.data.rowColor) {
			e.rowElement.style.backgroundColor = e.data.rowColor;
			e.rowElement.className = e.rowElement.className.replace('dx-row-alt', '');
		}
	}

	//Retrieving which tabs we should show by doing a distinct expression on the jobLogType
	getDistinctItems() {
		this.tabs = [];
		this.tabsSubject.next(this.tabs);
		this.setupTabs();
		//We retrieve the distinct values of the retrieved items here
		const unique = [...new Set(this.LogTypPropertiesMapping.getValue().map(item => item.LogType))];
		//We set the tab visibility based on the items here again
		this.tabs.forEach(e => {
			if (unique.includes(e.id.toString())) {
				e.visible = true;
			}
		});
		this.tabsSubject.next(this.tabs);
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	//Admin function for azure logs
	adminAzureInstanceLogs(instanceId: string) {
		this.prettyJsonComponentpicklist.onSessionId(instanceId);
		this.prettyJsonComponentpicklist.toggleModal(true);
	}

	public get JobLogType(): typeof JobLogType {
		return JobLogType;
	}

	hideExpandedMessageVisible(e) {
		console.log(e);
	}

	@bind
	expandMessageButton(e) {
		if (e.row.key.message) {
			//this.expandedMessageContent = e.row.key.message;
			this.isExpandedMessageSubject.next(e.row.key.message);
			this.isExpandedMessageVisible = true;
		}
		else if (e.row.key.description) {
			//this.expandedMessageContent = e.row.key.message;
			this.isExpandedMessageSubject.next(e.row.key.description);
			this.isExpandedMessageVisible = true;
		}
		else if (e.row.key.difference) {
			//this.expandedMessageContent = e.row.key.message;
			this.isExpandedMessageSubject.next(e.row.key.difference);
			this.isExpandedMessageVisible = true;
		}
	}

	ngOnInit(): void {
		//Retrieve the enum list
		this.enumList = this.toArray(JobLogType);
		//Retrieve the list of jobs

		this.asamcoUserService.isAdmin().then(result => {
			this.isAdminSubject.next(result);
		});

		// this.jobLogService.testFunc().subscribe(e => {
		// 	console.log(e)
		// })
	}
}
